<template>
    <v-content>
        <div>
            <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
            <div slot="table-actions">
                <div class="my-1">
                    <v-row>
                        <v-col>
                            <v-btn color="primary" v-if="fiscalYearID>0" @click.stop="addModal">{{$t('addreport')}}</v-btn>
                        </v-col>
                        <v-col md="4">
                            <v-select v-model.number="fiscalYearID" dense outlined
                                      :items="fiscalYearList"
                                      item-text="text"
                                      item-value="value">
                                <template v-slot:label>
                                    {{ $t("fiscal_year") }}
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <vue-good-table :columns="columns"
                            :rows="rows"
                            mode="remote"
                            :totalRows="customerData.totalRecords"
                            :pagination-options="{ enabled: true,mode: 'records',perPageDropdown: [15, 50, 100] }"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            styleClass="vgt-table condensed">
                <template slot="table-column" slot-scope="props">
                    <span>
                        {{ $t(props.column.label) }}
                    </span>
                </template>
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'actions'">
                        <!--<v-icon dense class="mr-2" @click.stop="reportItem(props.row)" style="color:dodgerblue">visibility</v-icon>-->
                        <v-icon dense class="mr-2" @click.stop="editItem(props.row)" style="color:dodgerblue">edit</v-icon>
                        <v-icon dense @click="deleteItemRoom(props.row)" style="color:red">delete  </v-icon>
                    </span>
                </template>
            </vue-good-table>




            <v-dialog v-model="snackbar.formModal"
                      transition="dialog-bottom-transition"
                      fullscreen
                      hide-overlay>
                <v-card>
                    <SubjectForm @dialogueClose="dialogueClose"
                                 @formResponse="formResponse"
                                 :subjectFormData="subjectFormData"
                                 v-if="snackbar.createFormComponent"
                                 ref="subjectForm"></SubjectForm>
                    <ReportEditForm @dialogueClose="dialogueClose"
                                    @formResponse="formResponse"
                                    v-if="snackbar.editFormComponent"
                                    :editItemIndex="customerData.editItemIndex"></ReportEditForm>
                </v-card>
            </v-dialog>



            <v-dialog v-model="snackbar.reportformModal"
                      transition="dialog-bottom-transition"
                      fullscreen
                      hide-overlay>
                <v-card>
                    <SubjectReportView @dialogueCloseView="dialogueCloseView"
                                 @formResponse="formResponse"
                                 :subjectReportViewData="subjectReportViewData"
                                 v-if="snackbar.viewFormComponent"
                                 ref="subjectReportView"></SubjectReportView>
                   
                </v-card>
            </v-dialog>


            <v-dialog v-model="snackbar.dialogDelete" max-width="500px">
                <deleteListData :deleteFormData="customerData.deleteFormData"
                                @formResponse="onResponseDelete"></deleteListData>
            </v-dialog>
            <v-snackbar v-model="snackbar.snackbar"
                        :color="snackbar.color"
                        :timeout="snackbar.timeout"
                        top>
                {{ snackbar.text }}
                <v-btn dark
                       text
                       @click="snackbar.snackbar = false">
                    Close
                </v-btn>
            </v-snackbar>
        </div>
    </v-content>
</template>

<script>
    import axios from "axios";
    import SubjectForm from "./SubjectReportForm";
    import SubjectReportView from "./SubjectReportView";
    import ReportEditForm from "./SubjectReportEditForm";
    import deleteListData from "@/components/deleteModal";
    export default {
        name: "ReportList",
        components: {
            'SubjectForm': SubjectForm,
            'ReportEditForm': ReportEditForm,
            'SubjectReportView': SubjectReportView,
            'deleteListData': deleteListData
        },
        data() {
            return {
                role: this.$store.getters.getUserRole,
                columns: [
                    {
                        label: "fiscal_year",
                        field: "fiscalYearName"
                    },
                    {
                        label: "actions",
                        field: "actions",
                        sortable: false
                    }
                ],
                rows: [],
                fiscalYearList: [],
                fiscalYearID: 0,
                subjectFormData: {},
                subjectReportViewData: {},
                customerData: {
                    totalRows: 0,
                    editItemIndex: null,
                    deleteFormData: {}
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "fiscalYearID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 15
                },
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    reportformModal: false,
                    createFormComponent: false,
                    editFormComponent: false,
                    viewFormComponent: false,
                    dialogDelete: false,
                    breadcrumbItems: [
                        {
                            text: 'dashboard',
                            disabled: false,
                            to: 'superAdminDashboard',
                        },
                        {
                            text: 'Subject Title',
                            disabled: true,
                        },
                    ],
                    dynamicComponent: {
                        current: 'SectionsForm'
                    }
                }
            };
        },
        computed: {
            breadcrumbItems() {

                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: 'IncomeSourceDashboard',
                        exact: true
                    },
                    {
                        text: this.$t('fiscalYearIncomeReport'),
                        disabled: true,
                    },
                ]
            }
        },

        methods: {
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            addModal() {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
                let model = {
                    fiscalYearID: this.fiscalYearID,
                }
                this.subjectFormData = model;

                this.snackbar.createFormComponent
                    this.$refs.subjectForm.loadItems();
            },


            reportItem(item) {
                this.snackbar.reportformModal = true
                this.snackbar.viewFormComponent = true
                let model = {
                    fiscalYearID: item.fiscalYearID,
                }
                this.subjectReportViewData = model;

                this.snackbar.viewFormComponent
                this.$refs.subjectReportView.loadItems();
            },

            editItem(item) {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
                let model = {
                    fiscalYearID: item.fiscalYearID,
                }
                this.subjectFormData = model;

                this.snackbar.createFormComponent
                    this.$refs.subjectForm.loadItems();
            },
            deleteItemRoom(item) {
                this.snackbar.dialogDelete = true;
                this.customerData.deleteFormData.url = "ReportSettings/DeleteIncomeBudgetLevelTwo/" + item.fiscalYearID;
                this.loadItems();
            },
            onResponseDelete() {
                this.snackbar.dialogDelete = false;
                this.loadItems();
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
                this.loadItems();
            },
            dialogueClose() {
                this.customerData.editItemIndex = null
                this.snackbar.formModal = false
                this.snackbar.createFormComponent = false
                this.snackbar.editFormComponent = false
                this.snackbar.viewFormComponent = false
                this.loadItems()
            },
            dialogueCloseView() {
                this.snackbar.reportformModal = false
                this.snackbar.viewFormComponent = false
            },
          
            async loadItems() {
                this.snackbar.isLoading = true;
                let param = {
                    PageSize: this.serverParams.perPage == -1 ? this.customerData.totalRecords : this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field,
                };
                axios.post('ReportSettings/IncomeLevelTwoList', param).then(response=>{
                    this.rows = response.data.data
                    this.customerData.totalRecords = response.data.totalCount
                })
            },
            fiscalyear() {
                axios.get("ReportSettings/GetFiscalYearList").then(response => {
                    this.fiscalYearList = response.data
                })
            }
        },
        mounted() {
            this.loadItems()
            this.fiscalyear()
        },

        
    }
</script>

<style scoped>

</style>
